<template>
  <template v-if="isVisible">
    <Modal
      :title="$lng.__('lk_webmaster_main', 'Welcome to NetvŌrk!')"
      :logotype="true"
      class="account-not-activated"
      v-if="showModalActivateAccount"
      @close="close()"
    >
      <p class="account-not-activated__text">
        {{
          $lng.__(
            'lk_webmaster_main',
            'To find the most profitable offers for you, we have prepared a short introduction - our Telegram bot will ask a couple of questions and immediately show suitable options. It will take no more than a minute!'
          )
        }}
      </p>
      <a
        :href="`https://t.me/netvorkreg_bot${user ? `?start=${user.id}` : ''}`"
        target="_blank"
        class="account-not-activated__button wv-btn--text wv-btn--green-active"
        >{{ $lng.__('lk_webmaster_main', 'Go to the bot') }}
      </a>
    </Modal>
  </template>
</template>

<script>
  import Modal from '@/components/Modal.vue';

  export default {
    name: 'AccountNotActivatedV2',
    components: { Modal },
    data() {
      return {
        isVisible: false,
        showModalActivateAccount: true,
        intervalId: null,
      };
    },
    computed: {
      manager() {
        return this.$store.state.webmaster.manager;
      },
      user() {
        return this.$store.state.auth.user;
      },
      isVisible() {
        return (
          this.$store.getters['auth/isUserLoaded'] &&
          !this.$store.getters['auth/isUserApproved']
        );
      },
    },
    methods: {
      checkShowModal() {
        if (localStorage.getItem('showModalActivateAccount')) {
          const lastShowTime = Number(localStorage.getItem('showModalActivateAccount'));
          const now = Date.now();
          const diff = now - lastShowTime;
          if (diff < 240 * 1000) {
            this.showModalActivateAccount = false;
          } else {
            this.showModalActivateAccount = true;
          }
        } else {
          this.showModalActivateAccount = true;
        }
      },
      close() {
        localStorage.setItem('showModalActivateAccount', Date.now());
        this.showModalActivateAccount = false;
        this.$emit('close');
      },
      sendMetrics() {        
        ym(46914753, 'reachGoal', 'PopupFirstView');
        fbq('trackCustom', 'PopupFirstView', {
          popup_id: 'pop_up_reg_bot',
        });
        gtag('event', 'conversion', {'send_to': 'AW-10869837654/sc4hCK7fovoaENaekr8o'});
        tgp('event', 'Rd4m73xR-qfKfjfEb');
      },
    },
    watch: {
      user(newVal, oldVal) {
        if (
          newVal.is_approved == false &&
          !localStorage.getItem('AccountNotActivatedV2_firstShow')
        ) {
          localStorage.setItem('AccountNotActivatedV2_firstShow', Date.now());
          this.sendMetrics();
        }
      },
    },
    beforeMount() {
      this.$store.dispatch('auth/getUser');
    },
    mounted() {
      this.intervalId = setInterval(() => {
        this.checkShowModal();
      }, 300000);
    },
    beforeDestroy() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        localStorage.removeItem('showModalActivateAccount');
      }
    },
  };
</script>

<style lang="scss">
  @import '../../../scss/utils/mixins.scss';
  @import '../../../scss/utils/variables.scss';

  .account-not-activated {
    .ui_modal_title {
      text-align: left;
      padding: 30px 55px 0;
      font-family: 'Montserrat';
      font-weight: 700;
      font-style: Bold;
      font-size: 30px;
      line-height: 120%;
      letter-spacing: 0%;
      border-bottom: none;
    }
    &__text {
      padding: 30px 35px 35px;
      font-family: 'Montserrat';
      font-weight: 500;
      font-style: Medium;
      font-size: 18px;
      line-height: 120%;
      letter-spacing: 0%;
    }
    &__button {
      margin: 0 auto;
      width: fit-content;
      font-family: Montserrat;
      font-weight: 500;
      font-style: Medium;
      font-size: 18px;
      line-height: 120%;
      letter-spacing: 0%;
      background: linear-gradient(95.67deg, #2EB0EB -5.54%, #735AEA 40.63%, #EB41C7 86.81%);
    }
  }
</style>